<template>
  <div class='home'>
    <VariantList
      v-show='listView'
      @newVariant='onClickNewFromList'
      @editVariant='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <VariantForm
      v-show='formView'
      :variant='variant'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import VariantList from '@/components/variant/VariantList.vue'
import VariantForm from '@/components/variant/VariantForm.vue'

export default {
  name: 'Variant',
  components: {
    VariantList,
    VariantForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      variant: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.variant = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.variant = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.variant = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {}
}
</script>
